/**
 * Product Page Scripts
 * Extracted from main-product.liquid inline <script> blocks
 *
 * Required DOM elements:
 * - #product-form[data-currency-symbol]: Currency symbol for price formatting
 * - script[data-product-variants]: JSON array of product variants
 * - script[data-product-analytics]: JSON object with product data for GA4
 */

/* === 1. Variant Selector & Gallery === */
document.addEventListener('DOMContentLoaded', function() {
  // P1 Fix: Added comprehensive error handling and defensive null checks
  try {
    const productForm = document.getElementById('product-form');
    if (!productForm) {
      console.warn('Product form not found');
      return;
    }

    const currencySymbol = productForm.dataset.currencySymbol || '$';
    const variantIdInput = productForm.querySelector('input[name="id"]');
    const colorDisplaySpan = document.querySelector('.color-value-display');
    const sizeDisplaySpan = document.querySelector('.size-value-display');
    const priceDisplaySpan = document.querySelector('.price-value-display');
    const addToBagButton = productForm.querySelector('.add-to-bag-button');
    const priceElement = document.querySelector('.product-info .current-price');
    const comparePriceElement = document.querySelector('.product-info .compare-price');
    const mainImage = document.querySelector('.product-featured-image');
    const variantDataScript = document.querySelector('[data-product-variants]');

    let productVariants = [];
    try {
      productVariants = variantDataScript ? JSON.parse(variantDataScript.textContent) : [];
    } catch (parseError) {
      console.error('Failed to parse product variants:', parseError);
      productVariants = [];
    }

  function findAndUpdateVariant() {
    const selectedOptions = [];
    const optionElements = productForm.querySelectorAll('.product-options');
    let isGiftCard = false; // Flag to check if it's a gift card

    optionElements.forEach((optionContainer, index) => {
        const optionType = optionContainer.querySelector('.option-title').textContent.split('/')[0].trim();
        let selectedValue = null;
        if (optionType === 'Color') {
          const checkedRadio = optionContainer.querySelector('.color-swatch-radio:checked');
          if(checkedRadio) selectedValue = checkedRadio.value;
        } else if (optionType === 'Size') {
          const selectedButton = optionContainer.querySelector('.option-value--size.selected');
          if(selectedButton) selectedValue = selectedButton.dataset.value;
        } else if (optionType === 'Price') {
          const selectedButton = optionContainer.querySelector('.option-value--price.selected');
          if(selectedButton) selectedValue = selectedButton.dataset.value;
          isGiftCard = true; // Set flag if Price option is found
        }

        if (selectedValue) {
            selectedOptions[index] = selectedValue;
        }
    });

    console.log('Selected Options:', selectedOptions);

    const matchedVariant = productVariants.find(variant => {
        return selectedOptions.every((optionValue, index) => {
            return variant.options[index] === optionValue;
        });
    });

    console.log('Matched Variant:', matchedVariant);

    // P1 Fix: Added null check before accessing variant properties
    if (matchedVariant) {
        if (variantIdInput) {
          variantIdInput.value = matchedVariant.id;
        }

        // Update Price
        if (priceElement && typeof matchedVariant.price !== 'undefined') {
            priceElement.textContent = formatMoney(matchedVariant.price, currencySymbol);
        }
        // Update Compare Price (optional, handle visibility)
        if (comparePriceElement) {
           if (isGiftCard) { // If it's a gift card, always hide compare price
               comparePriceElement.style.display = 'none';
           } else if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
               comparePriceElement.textContent = 'Comp. value ' + formatMoney(matchedVariant.compare_at_price, currencySymbol);
               comparePriceElement.style.display = '';
           } else {
               comparePriceElement.style.display = 'none';
           }
        }

        // Update Button State
        if (addToBagButton) {
            if (matchedVariant.available) {
                addToBagButton.disabled = false;
                addToBagButton.textContent = 'Add to Bag';
            } else {
                addToBagButton.disabled = true;
                addToBagButton.textContent = 'Sold Out';
            }
        }

        // Update Image (Optional - if variant has specific media)
        if (matchedVariant.featured_media && matchedVariant.featured_media.preview_image && mainImage) {
            mainImage.src = matchedVariant.featured_media.preview_image.src;
            // Update active thumbnail if needed
            const activeThumb = document.querySelector(`.product-thumbnail[data-media-id="${matchedVariant.featured_media.id}"]`);
            document.querySelectorAll('.product-thumbnail.active').forEach(t => t.classList.remove('active'));
            if(activeThumb) activeThumb.classList.add('active');
        }

    } else {
        console.warn('No matching variant found for options:', selectedOptions);
        // Optionally disable button if no variant matches
        if (addToBagButton) {
            addToBagButton.disabled = true;
            addToBagButton.textContent = 'Unavailable';
        }
    }
  }

  // Helper function to format money (basic example)
  function formatMoney(cents, symbol) {
      symbol = symbol || '$';
      const value = (cents / 100).toFixed(2);
      return symbol + value;
  }

  const thumbnails = document.querySelectorAll('.product-thumbnail');
  let currentIndex = 0;
  const thumbnailArray = Array.from(thumbnails);
  // Find initial active index
  thumbnailArray.forEach((thumb, idx) => {
    if (thumb.classList.contains('active')) currentIndex = idx;
  });
  function fadeToImage(newSrc, newIndex) {
    if (!mainImage) return;
    mainImage.classList.add('fade-out');
    setTimeout(() => {
      mainImage.src = newSrc;
      mainImage.classList.remove('fade-out');
      // Update active thumbnail
      thumbnails.forEach(t => t.classList.remove('active'));
      if (thumbnailArray[newIndex]) thumbnailArray[newIndex].classList.add('active');
      currentIndex = newIndex;
    }, 10);
  }
  thumbnails.forEach((thumbnail, idx) => {
    thumbnail.addEventListener('click', function() {
      const newSrc = this.dataset.full;
      fadeToImage(newSrc, idx);
    });
    // Add hover functionality
    thumbnail.addEventListener('mouseenter', function() {
      const newSrc = this.dataset.full;
      fadeToImage(newSrc, idx);
    });
  });
  // Next arrow logic
  const nextArrow = document.querySelector('.product-image-next-arrow');
  if (nextArrow) {
    nextArrow.addEventListener('click', function(e) {
      e.preventDefault();
      let nextIdx = (currentIndex + 1) % thumbnailArray.length;
      const newSrc = thumbnailArray[nextIdx].dataset.full;
      fadeToImage(newSrc, nextIdx);
    });
  }

  // --- Updated Variant Selection Handling ---
  function handleVariantSelectionUI(targetElement) {
       const optionContainer = targetElement.closest('.product-options');
       if (!optionContainer) return;
       const value = targetElement.dataset.value || targetElement.value;
       const optionTitleElement = optionContainer.querySelector('.option-title');
       const isColorOption = optionTitleElement?.classList.contains('option-title--color');
       const isSizeOption = optionTitleElement?.classList.contains('option-title--size');
       const isPriceOption = optionTitleElement?.classList.contains('option-title--price');

       // Update Button/Radio UI
       if (targetElement.matches('.option-value--size')) {
          optionContainer.querySelectorAll('.option-value--size').forEach(btn => btn.classList.remove('selected'));
          targetElement.classList.add('selected');
       } else if (targetElement.matches('.option-value--price')) {
          optionContainer.querySelectorAll('.option-value--price').forEach(btn => btn.classList.remove('selected'));
          targetElement.classList.add('selected');
       }

       // Update Dynamic Header Text
       if (isColorOption && colorDisplaySpan) {
          const checkedColorRadio = productForm.querySelector('.color-swatch-radio:checked');
          if (checkedColorRadio) colorDisplaySpan.textContent = checkedColorRadio.value;
       }
       if (isSizeOption && sizeDisplaySpan) {
           if (targetElement.matches('.option-value--size')) {
               sizeDisplaySpan.textContent = value;
           } else {
               const selectedSizeButton = productForm.querySelector('.option-value--size.selected');
               if(selectedSizeButton) sizeDisplaySpan.textContent = selectedSizeButton.dataset.value;
           }
       }
       if (isPriceOption && priceDisplaySpan) {
           if (targetElement.matches('.option-value--price')) {
               priceDisplaySpan.textContent = value;
           } else {
               const selectedPriceButton = productForm.querySelector('.option-value--price.selected');
               if(selectedPriceButton) priceDisplaySpan.textContent = selectedPriceButton.dataset.value;
           }
       }

       // Find and update the actual variant based on selections
       findAndUpdateVariant();
  }

  // Listen for changes on radio buttons (Color)
  productForm.addEventListener('change', function(event) {
      if (event.target.matches('.color-swatch-radio')) {
         handleVariantSelectionUI(event.target);
      }
  });

  // Listen for clicks on size buttons
  productForm.addEventListener('click', function(event) {
     const sizeButton = event.target.closest('.option-value--size');
     if (sizeButton) {
        handleVariantSelectionUI(sizeButton);
     }
     const priceButton = event.target.closest('.option-value--price');
     if (priceButton) {
        handleVariantSelectionUI(priceButton);
     }
  });

  // Initial setup on page load
  findAndUpdateVariant();

  } catch (error) {
    // P1 Fix: Global error handler for variant selector
    console.error('Product variant selector error:', error);
  }
});

/* === 2. Thumbnail Height Sync === */
document.addEventListener('DOMContentLoaded', function() {
  // Function to adjust thumbnail height based on main image
  function syncProductImageThumbnailsHeight() {
    const mainImageHeightSource = document.querySelector('.product-featured-image-container');
    const thumbnailsContainer = document.querySelector('.product-thumbnails');

    if (mainImageHeightSource && thumbnailsContainer) {
      const setMaxHeight = () => {
        const mainImageHeight = mainImageHeightSource.offsetHeight;
        if (mainImageHeight > 0) { // Only set if height is valid
          thumbnailsContainer.style.maxHeight = `${mainImageHeight}px`;
        }
      };

      requestAnimationFrame(() => {
        requestAnimationFrame(setMaxHeight);
      });

      const observer = new ResizeObserver(entries => {
        requestAnimationFrame(setMaxHeight);
      });
      observer.observe(mainImageHeightSource);
    }
  }

  // Call the sync function if the elements are present on this product page
  if (document.querySelector('.product-featured-image-container') && document.querySelector('.product-thumbnails')) {
    syncProductImageThumbnailsHeight();
  }
});

/* === 3. GA4 Product Page View Tracking === */
document.addEventListener('DOMContentLoaded', function() {
  if (window.ga4Ecommerce) {
    var analyticsScript = document.querySelector('[data-product-analytics]');
    if (analyticsScript) {
      try {
        var productData = JSON.parse(analyticsScript.textContent);
        window.ga4Ecommerce.trackViewItem(productData);
      } catch (e) {
        console.error('Failed to parse product analytics data:', e);
      }
    }
  }
});
